import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const VivaEngageAppSearch = () => import(/* webpackChunkName: "4-feat-vivaengageappsearch" */ './VivaEngageAppSearch');
export default lazyLoadOnRender({ loader: VivaEngageAppSearch });
